import {
	TrainingProgramSchema,
	type TrainingProgramEntry,
} from '#app/routes/mocra+/_form+/components/training-programs/schema.ts'
import {
	collectTrainingProgramErrors,
	createTrainingProgramDraft,
	sanitizeTrainingProgramDraft,
	trainingProgramDraftToEntry,
	trainingProgramEntryToDraft,
	type TrainingProgramDraft,
} from '#app/routes/mocra+/_form+/components/training-programs/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const trainingProgramDefinition = assertEntityDefinition<
	TrainingProgramEntry,
	TrainingProgramDraft
>({
	schema: TrainingProgramSchema,
	createDraft: () => createTrainingProgramDraft(),
	sanitizeDraft: sanitizeTrainingProgramDraft,
	serialize: trainingProgramDraftToEntry,
	deserialize: trainingProgramEntryToDraft,
	collectErrors: collectTrainingProgramErrors,
})

export type TrainingProgramEntityDraft = TrainingProgramDraft
